import type { CalendarMeetingItem } from '@/lib/meetings.ts';

export interface ConversationMonth {
  /** Stable across renders, so a growing list keeps its React keys. */
  key: string;
  /** The first of the month, for the header's own formatting. */
  month: Date;
  conversations: CalendarMeetingItem[];
}

/**
 * The conversations under a header per month.
 *
 * Grouped in the browser rather than asked of the backend: the list already
 * arrives in the right order, and a month is only a place for the eye to rest —
 * making it a query would put a second definition of "one page" in the API.
 *
 * The order it was handed in is kept exactly, headers included, so a row never
 * moves because of how it was grouped.
 */
export function groupByMonth(conversations: CalendarMeetingItem[]): ConversationMonth[] {
  const months: ConversationMonth[] = [];

  for (const conversation of conversations) {
    const startsAt = new Date(conversation.starts_at);
    const key = `${startsAt.getFullYear()}-${startsAt.getMonth()}`;
    const current = months.at(-1);

    if (current?.key === key) {
      current.conversations.push(conversation);
      continue;
    }

    months.push({
      key,
      month: new Date(startsAt.getFullYear(), startsAt.getMonth(), 1),
      conversations: [conversation],
    });
  }

  return months;
}
